import React from 'react';
import Modal from './Modal';
import './ServerErrorModal.css';

interface ServerErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry?: () => void;
  errorMessage?: string;
  statusCode?: number;
}

const ServerErrorModal: React.FC<ServerErrorModalProps> = ({
  isOpen,
  onClose,
  onRetry,
  errorMessage,
  statusCode
}) => {
  const getErrorMessage = () => {
    if (errorMessage) return errorMessage;
    
    if (statusCode === 500) {
      return 'Error interno del servidor. Nuestro equipo ha sido notificado y está trabajando en solucionarlo.';
    }
    if (statusCode === 503) {
      return 'El servidor está temporalmente no disponible. Por favor, intenta nuevamente en unos momentos.';
    }
    if (statusCode === 502 || statusCode === 504) {
      return 'Error de conexión con el servidor. Por favor, verifica tu conexión a internet e intenta nuevamente.';
    }
    
    return 'Ha ocurrido un error en el servidor. Por favor, intenta nuevamente más tarde.';
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Error del servidor"
      onConfirm={onRetry || onClose}
      confirmText={onRetry ? "Reintentar" : "Entendido"}
      cancelText={onRetry ? "Cancelar" : ""}
    >
      <div className="server-error-content">
        <p>{getErrorMessage()}</p>
        {statusCode && (
          <p className="server-error-code">Código de error: {statusCode}</p>
        )}
        {onRetry && (
          <p className="server-error-hint">
            Si el problema persiste, contacta al soporte técnico.
          </p>
        )}
      </div>
    </Modal>
  );
};

export default ServerErrorModal;
